<template>
    <div class="cart">
        <div class="container p-0">
            <div v-if="cart.items.length == 0" class="col-12 float-left mt-5 mb-5">
                <b-jumbotron class="text-center">
                    <h1>
                        <font-awesome-icon icon="shopping-cart" />
                    </h1>
                    <p>سبد خرید شما خالی است !!</p>
                </b-jumbotron>
            </div>
            <div v-else class="col-12 float-left mt-5 mb-5">
                <table v-if="screenWidth > 1021" class="table table-bordered table-striped text-center">
                    <tr>
                        <th>ردیف</th>
                        <th>نام محصول</th>
                        <th>دسته بندی</th>
                        <th>تعداد</th>
                        <th>قیمت واحد</th>
                        <th>قیمت کل</th>
                        <th>حذف از سبد خرید</th>
                    </tr>
                    <tr v-for="(item,index) in cart.items">
                        <td>{{ index +1 }}</td>
                        <td>
                            <router-link class="text-dark" :to="{ name: 'product', params:{ id: item.product.productId,  name: item.product.name.replace(/ /gi, '-') }}">
                                {{ item.product.name }}
                            </router-link>
                        </td>
                        <td>{{ item.product.productCategoryName }}</td>
                        <td>
                            <font-awesome-icon class="ml-3" @click="increment(index)" style="font-size:13px;cursor:pointer;" icon="plus" />
                            {{ item.count }}
                            <font-awesome-icon class="mr-3" @click="decrement(index)" style="font-size:13px;cursor:pointer;" icon="minus" />
                        </td>
                        <td>{{ new Intl.NumberFormat().format((item.product.price)) }} ریال</td>
                        <td>{{ new Intl.NumberFormat().format((item.product.price * item.count)) }} ریال</td>
                        <td>
                            <button @click="removeFromCart(item.product)" class="btn btn-danger btn-sm">
                                <font-awesome-icon class="ml-4" style="font-size:17px;" icon="trash" />
                                <span>حذف از سبد خرید</span>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3"><strong>مجموع</strong></td>
                        <td>{{ cart.items.length }}</td>
                        <td>{{ new Intl.NumberFormat().format(cart.unitTotalPrice) }} ریال</td>
                        <td>{{ new Intl.NumberFormat().format(cart.totalPrice) }} ریال</td>
                        <td></td>
                    </tr>
                </table>
                <table v-if="screenWidth < 1024"
                       v-for="(item,index) in cart.items"
                       class="table table-light shadow-sm table-silver text-right" v-bind:class="{'table-silver': (index % 2 > 0)}">
                    <tr>
                        <th>نام محصول</th>
                        <td>
                            <router-link class="text-dark" :to="{ name: 'product', params:{ id: item.product.productId,  name: item.product.name.replace(/ /gi, '-') }}">
                                {{ item.product.name }}
                            </router-link>
                        </td>
                    </tr>
                    <tr>
                        <th>دسته بندی</th>
                        <td>{{ item.product.productCategoryName }}</td>
                    </tr>
                    <tr>
                        <th>تعداد</th>
                        <td>
                            <font-awesome-icon class="ml-3" @click="increment(index)" style="font-size:13px;cursor:pointer;" icon="plus" />
                            {{ item.count }}
                            <font-awesome-icon class="mr-3" @click="decrement(index)" style="font-size:13px;cursor:pointer;" icon="minus" />
                        </td>
                    </tr>
                    <tr>
                        <th>قیمت واحد</th>
                        <td>{{ new Intl.NumberFormat().format((item.product.price)) }} ریال</td>
                    </tr>
                    <tr>
                        <th>قیمت کل</th>
                        <td>{{ new Intl.NumberFormat().format((item.product.price * item.count)) }} ریال</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="pt-4">
                            <button @click="removeFromCart(item.product)" class="btn btn-danger float-left btn-sm">
                                <font-awesome-icon class="ml-4" style="font-size:17px;" icon="trash" />
                                <span>حذف از سبد خرید</span>
                            </button>
                        </td>
                    </tr>
                </table>

                <b-card v-if="!customer" bg-variant="light">
                    <b-card-text>
                        <div class="col-12 col-md-6 mt-2 text-center float-left offset-md-3">
                            <strong class="mt-2 mb-4 d-block">جهت تکمیل روند پرداخت ابتدا باید وارد شوید</strong>
                            <router-link class="btn btn-block btn-dark" :to="{name: 'auth',query: { redirect: 'cart' }}">
                                ورود به سیستم
                            </router-link>
                        </div>
                    </b-card-text>
                </b-card>
                <b-card v-else bg-variant="light" title="انتخاب روش پرداخت" sub-title="جهت ادامه مراحل خرید لطفا روش پرداخت مورد نظر خود را انتخاب نمایید.">
                    <b-card-text>
                        <div class="row">
                            <div class="col-12 col-md-3 mt-2 float-right">
                                <button class="btn btn-block btn-dark mt-2" type="button" @click="bankPaymentType(1)">
                                    <span>پرداخت با نیکارت</span>
                                </button>
                            </div>
                            <div class="col-12 col-md-3 mt-2 float-right">
                                <button class="btn btn-block btn-dark mt-2" type="button" @click="bankPaymentType(2)">
                                    <span>پرداخت با کارت بانکی</span>
                                </button>
                            </div>
                            <div class="col-12 col-md-6 mt-2 float-right">
                                <button class="btn btn-block btn-dark mt-2" type="button" @click="bankPaymentType(3)">
                                    <span>پرداخت با نیکارت و کارت بانکی</span>
                                </button>
                            </div>
                        </div>
                        <div class="w-100 float-left mt-4 alert alert-warning">
                            <strong>راهنما!</strong>
                            <ul>
                                <li>در روش پرداخت با نیکارت کل مبلغ فاکتور با نیکارت پرداخت میشود و همینطور کارمزد ماهانه اقساط نیکارت به مبلغ کل اضافه میشود. </li>
                                <li>در روش پرداخت با کارت بانکی میتوانید مبلغ فاکتور را با کارت های بانکی خود که دارای رمز دوم هستند پرداخت کنید. این روش کارمز ماهانه ندارد. </li>
                                <li>پرداخت با نیکارت و کارت بانکی ترکیب هر دو روش بالا است و پرداخت شما بخشی با نیکارت و بخشی با کارت بانکی انجام میشود، مبلغ پرداختی با کارت بانکی را نیز میتوانید مشخص نمایید.</li>
                            </ul>
                        </div>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
    import store from "@/store";
    import utility from "@/plugins/utility";
    const db = new utility.db();

    export default {
        data()
        {
            return {
                screenWidth: null,
                customer: store.customer,
                cart: store.cart
            };
        },

        beforeMount()
        {
            this.screenWidth = window.outerWidth;
            this.calculatePrice();
        },

        methods: {

            bankPaymentType(value)
            {
                this.$emit('bankPaymentType', value)
            },

            calculatePrice()
            {
                var unitTotalPrice = 0;
                var totalPrice = 0;

                for (var i = 0; i < store.cart.items.length; i++)
                {
                    unitTotalPrice += store.cart.items[i].product.price
                    totalPrice += (store.cart.items[i].product.price * store.cart.items[i].count)
                }

                this.cart.unitTotalPrice = unitTotalPrice
                this.cart.totalPrice = totalPrice
            },

            removeFromCart(product)
            {
                for (var i = 0; i < store.cart.items.length; i++)
                {
                    if (store.cart.items[i].product.productId == product.productId)
                    {
                        store.cart.items.splice(i, 1)
                    }
                }

                this.calculatePrice()
                db.insert("cart", store.cart);
            },

            increment(index)
            {

                if (store.cart.items[index].count < store.cart.items[index].product.count)
                {
                    store.cart.items[index].count += 1;
                    this.calculatePrice()

                } else
                {
                    this.$bvToast.toast('موجودی این کالا ' + store.cart.items[index].product.count +' عدد است', {
                        title: 'عدم موجودی کالا',
                        toaster: 'b-toaster-top-center',
                        variant: 'warning',
                        bodyClass: 'text-center',
                        noCloseButton: true,
                        solid: true
                    })
                }

            },

            decrement(index)
            {
                if (store.cart.items[index].count > 1)
                {
                    store.cart.items[index].count -= 1;
                    this.calculatePrice()
                }
            },
        }
    };
</script>
